// const server = "http://localhost";
// const domain = "localhost";
// const port = 9351;
const serverImg = 'https://emanuel.nbg1.your-objectstorage.com/public';
const server = process.env.server || "https://apiemanuelimport.mansolutions.app";
const port = process.env.port || 443;
const domain = process.env.domain || "oldemanuel.mansolutions.app";
export { server, port, domain, serverImg };
